"use strict";

exports.__esModule = true;
exports.getRuleForType = void 0;
var _variants = require("../../types/metadata/variants");
/*
  This rule system provides a type-safe mapping from style properties (as defined in ExplicitPropertyTypeValueMap/PropertyTypeValueMap)
  to strategies that convert values into CSS-ready outputs.
  Conditional types ensure each property is assigned a rule compatible with its declared value type, and the rule table enforces
  coverage for all explicitly known style properties (those in ExplicitPropertyTypeValueMap).
  Any css property that is not explicitly defined in ExplicitPropertyTypeValueMap
  will be converted using generic value to string strategy.
*/

const PROPERTY_TRANSFORMATION_RULES = {
  [_variants.StyleType.width]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.height]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.margin]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.marginTop]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.marginRight]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.marginBottom]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.marginLeft]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.marginInlineStart]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.marginInlineEnd]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.padding]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.paddingTop]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.paddingRight]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.paddingBottom]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.paddingLeft]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.paddingInlineStart]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.paddingInlineEnd]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.gap]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.color]: {
    type: 'color'
  },
  [_variants.StyleType.backgroundColor]: {
    type: 'color'
  },
  [_variants.StyleType.borderColor]: {
    type: 'color'
  },
  [_variants.StyleType.borderTopColor]: {
    type: 'color'
  },
  [_variants.StyleType.borderRightColor]: {
    type: 'color'
  },
  [_variants.StyleType.borderBottomColor]: {
    type: 'color'
  },
  [_variants.StyleType.borderLeftColor]: {
    type: 'color'
  },
  [_variants.StyleType.borderInlineStartColor]: {
    type: 'color'
  },
  [_variants.StyleType.borderInlineEndColor]: {
    type: 'color'
  },
  [_variants.StyleType.textDecorationColor]: {
    type: 'color'
  },
  [_variants.StyleType.font]: {
    type: 'font'
  },
  [_variants.StyleType.fontFamily]: {
    type: 'string'
  },
  [_variants.StyleType.fontSize]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.fontWeight]: {
    type: 'stringOrNumber'
  },
  [_variants.StyleType.fontStyle]: {
    type: 'string'
  },
  [_variants.StyleType.fontVariant]: {
    type: 'string'
  },
  [_variants.StyleType.lineHeight]: {
    type: 'stringOrNumber'
  },
  [_variants.StyleType.letterSpacing]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.textAlign]: {
    type: 'string'
  },
  [_variants.StyleType.textTransform]: {
    type: 'string'
  },
  [_variants.StyleType.border]: {
    type: 'border'
  },
  [_variants.StyleType.borderWidth]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.borderStyle]: {
    type: 'string'
  },
  [_variants.StyleType.borderRadius]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.borderTopLeftRadius]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.borderTopRightRadius]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.borderBottomLeftRadius]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.borderBottomRightRadius]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.borderStartStartRadius]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.borderStartEndRadius]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.borderEndStartRadius]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.borderEndEndRadius]: {
    type: 'stringOrNumber',
    unit: 'px'
  },
  [_variants.StyleType.booleanValue]: {
    type: 'boolean'
  },
  [_variants.StyleType.stringEnum]: {
    type: 'string'
  },
  [_variants.StyleType.numberEnum]: {
    type: 'stringOrNumber'
  },
  [_variants.StyleType.number]: {
    type: 'stringOrNumber'
  }
};
const getRuleForType = type => {
  return PROPERTY_TRANSFORMATION_RULES[type] || undefined;
};
exports.getRuleForType = getRuleForType;
//# sourceMappingURL=rules.js.map